import React from "react";
import { Line } from "react-chartjs-2";
import { ThemeType } from "../../types/index";
import { useNewData, useOptions } from "../../hooks/useGraph";
import { DataType } from "../../types/dataType";
import { dummyData } from "../../contains/dummyData";

export type LineChartProps = {
  className?: string;
  theme?: ThemeType;
  width?: string | number;
  height?: string | number;
  data: DataType;
};

export const lineChartdefaultProps: LineChartProps = {
  data: dummyData,
  theme: "light",
};

const LineChart = ({
  className,
  data,
  width,
  height,
  theme,
}: LineChartProps): JSX.Element => {
  const chartData = useNewData(data);
  const opt = useOptions("line", theme);

  return (
    <Line
      id="line-chart"
      data={chartData}
      className={className}
      options={opt}
      height={height}
      width={width}
    ></Line>
  );
};

LineChart.defaultProps = lineChartdefaultProps;

export default LineChart;
